/*================================================================================
	goodman.interface.map
================================================================================*/

(function($){

	window.goodman.interface.map = $.extend(true, window.goodman.interface.map || {}, {

		init: function() {
			var self = this;
			this.container = $('.property_map_container');
			this.typeContainer = $('#map-type-selector-container');
			this.disclaimerContainer = $('#map-disclaimer-container');
			this.attributionContainer = $('#map-attribution-container');
			this.esriLogoContainer = $('#map-esri-logo-container');
			goodman.observer.subscribe('map-start', self.start, self);
			goodman.observer.subscribe('map-type', self.changeType, self);
			this.render();
			this.enable();
		},

		render: function() {
			this.typeContainer.html( goodman.template['property-map-type'].hbs({types:goodman.config.mapTypes}) );
		},

		enable: function() {
			var self = this;

			this.typeContainer
				.on('click', '.property_map_type_link', function(){
					var newType = $(this).data('value');
					goodman.observer.publish('set-map-type', newType);
				});

			this.attributionContainer
				.on('click', '.map-attribution', function(){
					if ($(this).hasClass('attribution-open')) {
						$(this).removeClass('attribution-open');
						self.disclaimerContainer.css({'bottom': $(this).height() + 5});
					} else {
						$(this).addClass('attribution-open');
						self.disclaimerContainer.css({'bottom': $(this).height() + 5});
					}

				});
			this.esriLogoContainer
				.on('click', function(e){
					window.open('https://www.esri.com/', '_blank');
				});
		},

		start: function() {
			if (!goodman.config.isInternal && goodman.config.disclaimerURL) {
				$('<div class="map-disclaimer">Images displayed in this map are subject to <a href="'+goodman.config.disclaimerURL+'" target="_blank">this disclaimer</a></div>').appendTo(this.disclaimerContainer);
			}
			
			$('<div class="map-attribution">'+
				`Esri Community Maps Contributors | Vantor | DCCEEW | © OpenStreetMap, Microsoft | Esri | TomTom | Garmin | METI/NASA | USGS`+
				'</div>').appendTo(this.attributionContainer);
		},

		changeType: function(type) {
			var self = this;
			$('.property_map_type_link',this.typeContainer)
				.removeClass('active')
				.filter('[data-value="'+type+'"]')
				.addClass('active');
		},

	});

})(jQuery);
